import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useSession } from "../lib/auth-client";
import { getSessionDetail, type AdminSessionDetail } from "../lib/admin-api";
import { TranscriptViewer } from "../components/admin/TranscriptViewer";

export default function AdminSessionDetailRoute() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const session = useSession();
  const [detail, setDetail] = useState<AdminSessionDetail | null | "loading">("loading");

  useEffect(() => {
    if (session.isPending) return;
    if (!session.data) {
      navigate("/admin", { replace: true });
      return;
    }
    if (!id) return;
    void getSessionDetail(id).then((d) => setDetail(d));
  }, [id, session.isPending, session.data, navigate]);

  if (session.isPending || detail === "loading") {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <p className="text-sm text-ink-500">Loading…</p>
      </main>
    );
  }

  if (!session.data) return null;

  return (
    <main className="min-h-screen px-6 py-10 max-w-3xl mx-auto">
      <nav className="mb-8">
        <Link to="/admin" className="text-sm text-ink-500 hover:text-ink-700 transition-colors">
          ← All interviews
        </Link>
      </nav>
      {detail === null && (
        <p className="text-sm text-ink-500">Not found, or you don't have access.</p>
      )}
      {detail && <TranscriptViewer detail={detail} />}
    </main>
  );
}
